// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a4-sales-print-template {
  display:none;
}
.a4-sales-print-template-show {
  display:block !important;
  /*max-height: 1070px;*/
}

.a4-page-container {
  width: 210mm;
  height: 297mm;
  margin: auto;
  border: 1px solid;
  display: flex;
  justify-content: center;
  position: relative;
}

@media print {
  /*@page {*/
  /*  size: A4;*/
  /*  margin: 0;*/
  /*}*/

  header,footer {
    display: none !important;
  }

  body,
  html {
    -webkit-font-smoothing: none;
    width: 100% !important;
    height: 100% !important;
    /*height: 99% !important;*/
    padding: 0 !important;
    margin: 0 !important;
  }

  .a4-print-container {
    margin: 0 !important;
    padding: 0 20px !important;
    /*position: relative !important;*/
  }

  .a4-page-container {
    width: auto !important;
    border: 0 !important;
    display: block !important;
    /*position: unset !important;*/
  }

  .a4-page-break {
    page-break-after: always !important;
    page-break-inside: avoid !important;
  }
}

.product-description {
  padding: 2px 1px;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}

.a4-transactionDetailsTable tbody tr td:nth-child(1) {
  text-align: left;
}

.a4-transactionDetailsTable tbody tr td:nth-child(2) {
  text-align: right;
}

.a4-page-break {
  page-break-after: always !important;
  page-break-inside: avoid !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/InvoicePrint/invoicePrint.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;EACf,IAAI;;EAEJ;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;IAC5B,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,mCAAmC;IACnC,mCAAmC;EACrC;AACF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC","sourcesContent":[".a4-sales-print-template {\r\n  display:none;\r\n}\r\n.a4-sales-print-template-show {\r\n  display:block !important;\r\n  /*max-height: 1070px;*/\r\n}\r\n\r\n.a4-page-container {\r\n  width: 210mm;\r\n  height: 297mm;\r\n  margin: auto;\r\n  border: 1px solid;\r\n  display: flex;\r\n  justify-content: center;\r\n  position: relative;\r\n}\r\n\r\n@media print {\r\n  /*@page {*/\r\n  /*  size: A4;*/\r\n  /*  margin: 0;*/\r\n  /*}*/\r\n\r\n  header,footer {\r\n    display: none !important;\r\n  }\r\n\r\n  body,\r\n  html {\r\n    -webkit-font-smoothing: none;\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    /*height: 99% !important;*/\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .a4-print-container {\r\n    margin: 0 !important;\r\n    padding: 0 20px !important;\r\n    /*position: relative !important;*/\r\n  }\r\n\r\n  .a4-page-container {\r\n    width: auto !important;\r\n    border: 0 !important;\r\n    display: block !important;\r\n    /*position: unset !important;*/\r\n  }\r\n\r\n  .a4-page-break {\r\n    page-break-after: always !important;\r\n    page-break-inside: avoid !important;\r\n  }\r\n}\r\n\r\n.product-description {\r\n  padding: 2px 1px;\r\n  word-break: break-all;\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-line-clamp: 3;\r\n  line-clamp: 3;\r\n}\r\n\r\n.a4-transactionDetailsTable tbody tr td:nth-child(1) {\r\n  text-align: left;\r\n}\r\n\r\n.a4-transactionDetailsTable tbody tr td:nth-child(2) {\r\n  text-align: right;\r\n}\r\n\r\n.a4-page-break {\r\n  page-break-after: always !important;\r\n  page-break-inside: avoid !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
